module.exports = __webpack_public_path__ + "static/media/b.1cb52ac6.jpg";